import { useFormContext, useWatch } from 'react-hook-form'

import { Organisation } from '@percent/education-hosted-form/api/organisations/organisations.types'

// We need to store the metadata to display the details of the organisation and allow searching for it
export const ORGANISATION_QUESTION_METADATA = {
  QUERY: 'ORGANISATION_QUERY',
  ORGANISATION: 'ORGANISATION_METADATA'
} as const

const setValueOptions = { shouldValidate: false, shouldTouch: false }

export const useOrganisationField = () => {
  const { setValue, resetField } = useFormContext()

  const setOrganisationValue = (organisation: Organisation | undefined) => {
    setValue(ORGANISATION_QUESTION_METADATA.ORGANISATION, organisation, setValueOptions)
  }

  const setQueryValue = (query: string) => {
    setValue(ORGANISATION_QUESTION_METADATA.QUERY, query, setValueOptions)
    // Clear the organisation value when the query changes
    resetField(ORGANISATION_QUESTION_METADATA.ORGANISATION, { keepDirty: false, keepTouched: false })
  }

  return {
    organisation: useWatch({ name: ORGANISATION_QUESTION_METADATA.ORGANISATION }),
    query: useWatch({ name: ORGANISATION_QUESTION_METADATA.QUERY }),
    setOrganisationValue,
    setQueryValue
  }
}
